import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContentsWrapper = styled.div`
  position: relative;
`;

/**
 * HACK: 以下の理由により無理矢理モーダル画面外に移動させている
 *  - SEO観点で、Episodeの情報を出しておかないといけない
 *  - Episodeの情報を「visibility: hidden」で隠しても高さを保持してしまっており、無駄な余白ができてしまう
 */
export const DivContentsBox = styled.div<{ isShow: boolean }>`
  width: 100%;
  visibility: ${({ isShow }) => (isShow ? "visible" : "hidden")};
  opacity: ${({ isShow }) => (isShow ? 1 : 0)};
  position: ${({ isShow }) => (isShow ? "relative" : "absolute")};
  top: ${({ isShow }) => (isShow ? 0 : "-9999px")};
  left: ${({ isShow }) => (isShow ? 0 : "-9999px")};
`;

export const DivAnnotationBox = styled.div`
  margin-top: 32px;
  padding: 16px;
  font-size: ${FONT_SIZE.S}px;
  border: 1px solid ${COLOR.GRAY200.code};
  border-radius: 8px;
`;
